export const RECEIPT_FETCH_REQUEST='receipt-fetch-request';
export const RECEIPT_FETCH_SUCCESS='receipt-fetch-success';
export const RECEIPT_FETCH_FAILURE='receipt-fetch-failure';